__turbopack_context__.v({
  "container": "exportButtonWithLoader-module-scss-module__9cMFvq__container",
  "exporting": "exportButtonWithLoader-module-scss-module__9cMFvq__exporting",
  "spinner": "exportButtonWithLoader-module-scss-module__9cMFvq__spinner",
  "statusText": "exportButtonWithLoader-module-scss-module__9cMFvq__statusText",
});
